import {
  ModalContainerSize,
  HeaderComponents,
} from '../types/header-customizer';

export const DEFAULT_HEADER_COMPONENT_ICON = 'add';

export const CONTAINER_TYPE_OPTIONS = [
  {
    value: 'modal',
    label: 'Modal',
  },
  {
    value: 'popup',
    label: 'Popup',
  },
  {
    value: 'floating',
    label: 'Floating Box',
  },
];

export const getPopoverTriggerDataAttr = (key: string) => `icon-for-${key}`;

export const MODAL_SIZE_OPTIONS = [
  {
    value: ModalContainerSize.L,
    label: 'HITL.ui-customization.workspace.header-components.setup-component-form.modal-size-options.large',
  },
  {
    value: ModalContainerSize.M,
    label: 'HITL.ui-customization.workspace.header-components.setup-component-form.modal-size-options.medium',
  },
  {
    value: ModalContainerSize.S,
    label: 'HITL.ui-customization.workspace.header-components.setup-component-form.modal-size-options.small',
  },
];

export const DEFAULT_MIN_SIZE_OPTIONS = {
  minHeight: 200,
  minWidth: 200,
};

export const DEFAULT_MAX_MIN_SIZE = 640;
export const DEFAULT_MIN_MIN_SIZE = 1;

export const POPUP_DEFAULT_SIZE = {
  minHeight: 100,
  minWidth: 360,
};

export const FLOATING_DEFAULT_SIZE = {
  minHeight: 360,
  minWidth: 360,
};

export const HEADER_DEFAULT_COMPONENTS: HeaderComponents = {
  search: {
    icon: 'search',
    key: 'search',
    label: 'Search',
    position: 0,
    containerType: 'modal',
    modalSize: ModalContainerSize.M,
  },
};
